<kendo-datepicker
  #kendoDatePicker
  (focusin)="focus()"
  (focusout)="blur()"
  [format]="format()"
  placeholder=""
  [formControl]="$any(_control)"
  scrollPicker
  [min]="min()"
  [max]="max()"
  [popupSettings]="{
    appendTo: appendTo(),
  }"
>
  <kendo-datepicker-messages today="{{ translation.leftMenu.today | transloco }}" />

  <kendo-datetimepicker-messages
    accept="{{ translation.leftMenu.accept | transloco }}"
    cancel="{{ translation.leftMenu.cancel | transloco }}"
  />
</kendo-datepicker>
